import React, { useCallback } from 'react';
import clsx from 'clsx';
import { Input } from 'reactstrap';
import { TypedMemo } from '../../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the settings sections; each part uses its own slice of it */
import styles from './PlatformSettings.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SettingsSwitchRowProps {
  id: string;
  title: string;
  /** The help line, or the reason that the switch is disabled. */
  note?: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}

/** One on/off setting. Off is the start state of every switch that the platform guidelines name. */
const SettingsSwitchRowComponent: React.FC<SettingsSwitchRowProps> = ({
  id,
  title,
  note,
  checked,
  disabled = false,
  onChange,
}) => {
  const change = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.checked),
    [onChange]
  );
  return (
    <div className={clsx(styles.row, disabled && styles.rowOff)}>
      <label className={styles.rowText} htmlFor={id}>
        <span className={styles.rowTitle}>{title}</span>
        {note === undefined ? null : <span className={styles.small}>{note}</span>}
      </label>
      <Input id={id} type="switch" role="switch" checked={checked} disabled={disabled} onChange={change} />
    </div>
  );
};

export const SettingsSwitchRow = TypedMemo(SettingsSwitchRowComponent);
